import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../icon/Icon';
import { COLORS } from '../colors';
import classNames from 'classnames';
const ButtonLink = ({ children, href, to, color = 'primary', size = 'md', style = 'primary', className, iconPath, iconSize, iconPosition = 'right', iconTitle, id, disabled, }) => {
    const css = classNames('ac-btn', color, size, 'icon-' + iconPosition, 'style-' + style, { disabled: disabled }, className);
    if (disabled) {
        return (React.createElement("span", { className: css, id: id },
            React.createElement("span", { className: 'button-container' },
                iconPath && React.createElement(Icon, { path: iconPath, color: COLORS.gray700, size: iconSize, title: iconTitle }),
                React.createElement("span", { className: 'button-content' }, children))));
    }
    if (to) {
        return (React.createElement(Link, { to: to, className: css, id: id },
            React.createElement("span", { className: 'button-container' },
                iconPath && React.createElement(Icon, { path: iconPath, color: COLORS.gray700, size: iconSize, title: iconTitle }),
                React.createElement("span", { className: 'button-content' }, children))));
    }
    else if (href) {
        return (React.createElement("a", { href: href, className: css, id: id },
            React.createElement("span", { className: 'button-container' },
                iconPath && React.createElement(Icon, { path: iconPath, color: COLORS.gray700, size: iconSize, title: iconTitle }),
                React.createElement("span", { className: 'button-content' }, children))));
    }
};
export { ButtonLink };
//# sourceMappingURL=ButtonLink.js.map